export default function Footer() {
  return (
    <footer className="footer">
      <p>Copyright &copy; Nirajan Sah - 2022</p>
    </footer>
  );
}
